import type { ContentfulEntry } from "types/cms";

export const getContentType = (contentfulEntry: ContentfulEntry): string =>
  contentfulEntry.sys.contentType.sys.id;
